var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPwTip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2C72DE",
  fillRule: "evenodd",
  d: "M11.138 5.47 6 10.608 3.529 8.137l.942-.943L6 8.723l4.195-4.196z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2C72DE",
  fillRule: "evenodd",
  d: "M3.505 11.984a8 8 0 0 0 .267.198l.003.002.13.09.001.001a9 9 0 0 0 .28.182 8.1 8.1 0 0 0 2.683 1.063l.003.001.128.025.129-.025h.002a8.1 8.1 0 0 0 4.156-2.234l.063-.064a8.12 8.12 0 0 0 2.317-5.691 8.1 8.1 0 0 0-1.14-4.158l-.008-.014q-.217.046-.441.08h-.006q-.526.077-1.072.078a7.3 7.3 0 0 1-3.666-.98L7.329.533A7 7 0 0 1 7 .332q-.16.105-.328.202l-.006.003A7.3 7.3 0 0 1 3 1.518q-.546 0-1.072-.078-.227-.033-.447-.08l-.008.014a8.1 8.1 0 0 0-.904 2.203 8.2 8.2 0 0 0-.236 1.955 8.12 8.12 0 0 0 3.172 6.452M7 1.874a8.64 8.64 0 0 1-4.772.943 6.8 6.8 0 0 0-.561 2.715 6.79 6.79 0 0 0 2.877 5.563A6.8 6.8 0 0 0 7 12.185a6.77 6.77 0 0 0 3.396-1.894 6.8 6.8 0 0 0 1.937-4.76c0-.966-.2-1.883-.561-2.714A8.635 8.635 0 0 1 7 1.874",
  clipRule: "evenodd"
})));
export { SvgIconPwTip as ReactComponent };
export default __webpack_public_path__ + "img/icon-pw-tip.2786efee06c4378f8d038bb48df2ae2a.svg";